// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"2661cd66","609":"cf15a230"}[chunkId] + ".chunk.css";
};